import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
/*
  Generated class for the LoginProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoginProvider {

    url: string = 'http://qbankapiv2.showmywork.in/';

    constructor(public http: HttpClient) {
    }

    login(obj: any) {
        return this.http.post(this.url + 'login', obj).map(res => res);
    }

}



// WEBPACK FOOTER //
// ./src/providers/login.ts